import { TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0d3679",
    color: theme.palette.common.white,
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:hover": {
    backgroundColor: "#bcbccdff",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export const formatDate = (timestamp) => {
    if (!timestamp) return "";
    try {
      const date = new Date(timestamp * 1000); // Assuming timestamp is in seconds
      const year = date.getFullYear().toString().slice(2); // Get last two digits of year
      const month = ("0" + (date.getMonth() + 1)).slice(-2); // Add leading zero if needed
      const day = ("0" + date.getDate()).slice(-2); // Add leading zero if needed
      return `${year}/${month}/${day}`;
    } catch (e) {
      console.error("Error formatting date:", e);
      return "Invalid Date";
    }
  };

